import { render, staticRenderFns } from "./PaymentManageView.vue?vue&type=template&id=3f36cd23&scoped=true"
import script from "./PaymentManageView.vue?vue&type=script&lang=js"
export * from "./PaymentManageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f36cd23",
  null
  
)

export default component.exports